import { ToothDataEntry, ToothSurfaceDataType } from '../teethData';
import { ToothView } from '../../../Enums/ToothView.enum';
import {
	ToothFracturePosition,
	ToothFractureType,
	ToothSurface,
} from '../../../../../graphql/graphql';

export const Tooth17: ToothDataEntry = {
	[ToothView.PALATAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M206.5,62.2l-5.7,21.9-9.3,31.8-8.3,20c-121.3,32.3-166.4-7.8-166.4-7.8l-3.8-13.4-2.1-10.6-1.5-14.6-.2-15.7.4-10.6,3.4-9.8,8.1-12.5,12.3-10,12.3-4.2h22s11.9,2.3,11.9,2.3l14,4.9,6.6-3.8,8.5-3.8,9.1-2.1,11.2-1.3,10.6-1.3,12.3-1.1,10.4,1.1,11.9,3.4,11.9,5.1,10.6,6.4,9.1,8.5.8,17.2h0Z',
			},
			[ToothSurface.Palatal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M120.4,75.2a15.2,15.2 0 1,1 -30.4,0a15.2,15.2 0 1,1 30.4,0Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M163.4,23l8.5,2.3,8.4,3.1,8.2,3.7,7.4,4.7,5.7,4.4,4.3,7v17s-12.5,41.1-12.5,41.1h-27.7c-15.2,0-13.5-19-13.5-19V22s11.2,1,11.2,1Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M65.6,28.6l.2,65.7c0,15-14.8,12.3-14.8,12.3H12.7s-1.7-10.1-1.7-10.1l-1.1-8.9v-19.3s1.3-5.2,1.3-5.2l3-8.8,4.8-8.7,6.2-6.5,7.1-5.5,7.4-3.4,9.2-1.8,16.7.3h0Z',
			},
			[ToothSurface.CervicalPalatal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M183.3,136l-3.1,8.4c-108.5,38.3-156.9-2.7-156.9-2.7l-6.5-13.6c56.6,40.3,166.4,7.8,166.4,7.8h0Z',
			},
			[ToothSurface.MesioPalatalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M93.6,34.1c40.8,29.7,12.9,114.5,12.9,114.5,0,0,38.1-1.2,76.8-12.5l8.3-20,6.4-23.4,7-20.5,1.9-10.6v-8.2s-1.1-8.2-1.1-8.2l-9.1-8.5-10.6-6.4-11.9-5.1-11.9-3.4-10.4-1.1-22.9,2.3-20.3,3.4-15.1,7.6h0Z',
			},
			[ToothSurface.DistoPalatalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M16.9,128.1c30.1,23.8,89.6,20.3,89.6,20.3,27.4-95.4-12.9-114.5-12.9-114.5l-14-4.9-11.9-2.3h-22s-12.3,4.2-12.3,4.2l-12.3,10-8.1,12.5-3.4,9.8-.4,10.6.2,15.7,1.5,14.6,2.1,10.6,3.8,13.4h0Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Horizontal}`]: [
				'9.4 77.1 28.8 53.5 38.7 86.4 53.1 50.4 68.9 87.4 85.5 51.1 102.1 86.9 119.6 52.5 136.2 89.4 152.1 52.9 170.5 88.3 175.1 55.1 201 75.8',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Vertical}`]: [
				'105.5 403.6 93.1 382.4 109.7 377.5 94.3 365.2 109.4 359.4 93.8 347.6 109 339.1 94.4 330.5 108.7 322.3 92.7 312.8 107.7 304.2 94.3 296.1 110.4 286.9 95.7 278.2 110 270.2 95.1 261.3 108.8 253.4 93.7 244.4 108 236.3 95.1 228.6 106.9 221.8 93.6 213.9 106.3 207 93 198.9 106.5 191.4 94 183.9 106.3 177.1 93.7 169.7 109.1 161 96.4 153.3 109.7 145.8 96.6 137.8 111.5 129.4 97.7 121.1 113.7 112 100.1 103.8',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Horizontal}`]: [
				'160.6 265.7 149.2 250.1 137.6 266.1 123.6 248.6 112.2 263.6 99.4 248.3 86.7 263.6 76.6 249.8 65.9 263.6 55.7 248.6 48.2 263.4',
			],
		},
	},
	[ToothView.INCISAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M185.8,48.4h0l2,7.8,1.1,8.5.2,16.8-3.4,26.9-2.2,10.8-4.7,13.4-5.6,11.4-5.6,12.8-5.6,10.8-3.4,4.9-2.7,2.9-3.8,3.8-3.8,3.6-4.5,3.2-6.3,2.4-9.3,2.6-4.7,1.1h-3.9s-8.7-.4-8.7-.4l-4.9.2-3.9-.2-6.3-.9-12.6-.7-7.8-1.8-7.4-1.5-4.5-.9-6.9-2.9-3.2-2.2-6.5-2.4-7.1-5-6.1-4.1-3.6-4.7-3.8-6.9-2.4-4.5-2-6-1.3-4.5-.5-6.5-.5-8.2.2-7.1.2-6,10.1-33.3s.7-6.1.7-6.7.7-4.5.7-4.5l1.1-8.7,1.8-3.2,1.6-4.1,1.5-2.4,3.8-3.9,5.4-4.9,5.8-5,7.8-4.3,5-2.7,5.6-2.4,6.3-1.6,4.3-.5h5s11.7-.2,11.7-.2l2.9-.7,4.1-1.1,6.1-1.8,4.1-1.5,5.4-1.5,2.9-1.3,5.4-1.6,3.2-.2s5.8-.4,7.1-.4,2.4.2,2.4.2l4.7.9,5,1.1,5,1.8,4.5,2.2,4.3,2.6,5,2.7,4.5,3.9,2,2.2,2.2,2.6,2.4,2.9,3.9,8.9h.5Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M169.6,153.2l-27.4-33.5c-16.2-24.2,10.4-41.4,10.4-41.4l32.9-30.1,3,11.4,1,11.7-.2,15.6-2,15.9-5,17.9-4.5,14.6-5.5,9.7-2.7,8.2h0Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M36.2,55.6l19.8,24.9,8,9.6c15.8,16.2-2.8,31.9-2.8,31.9l-2.8,2.5-35.8,28.3-3.6-17.4.2-16.8.6-8,3.2-11.8,7-18,1.2-6.8,1.2-11.6,3.8-6.8h0Z',
			},
			[ToothSurface.MesioBuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M114.8,80.6c7.2,10.7,37.7-2.2,37.7-2.2l32.9-30.1-1.9-6.1-5.2-7.4-8.2-6.8-10.6-6.6-15.4-5.6-14,.2-23.8,7.8c-1.4,35,1.3,46.1,8.5,56.8Z',
			},
			[ToothSurface.DistoBuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M106.2,23.9c-1.8,32.6,8.5,56.8,8.5,56.8,0,0-12.8-19.1-31.8,1.4-5.8,6.2-27-1.6-27-1.6l-19.8-24.9,3.6-7.8,6-5.6,8-5.8,9.6-5.2,11.2-3.8,10.6-1.6,13.4.6,7.8-2.6h-.1Z',
			},
			[ToothSurface.DistoPalatalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M22.8,152.7l35.8-28.3,10.6-4.8s-2,2.5-.4,8.2c1.1,3.8-5.4-1.3,9.9,16.1,15.3,17.4,13,47.4,13,47.4l-11.1-1-13.7-2.6-16.5-6.6-12.9-8.2-9.6-10.9-5.3-9.3h.2Z',
			},
			[ToothSurface.MesioPalatalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M91.7,191.3c.7-33.3-13-47.4-13-47.4,0,0-16.9-15.1-9.5-24.3-.3,0,.7-3.5,10.4-3.5,9.7,0,9.5,8.3,20.3,8.3,10.8,0,15.4-10,24.8-10s17.5,5.3,17.5,5.3l27.4,33.5-9.1,16.6-8.2,9.2-12,8.9-15.8,3.4h-33s.2,0,.2,0Z',
			},
			[ToothSurface.Occlusal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M152.5,78.2c-33,24.7-.6,48.8-10.4,41.4,0,0-9.6-5.3-17.5-5.3-7.9,0-12.7,10-24.8,10s-16.6-8.3-20.3-8.3-21.1,8.3-21.1,8.3l2.8-2.5c22.5-20.5-7.9-41.5-5.2-41.5s20.2,9.6,27,1.6c6.8-8,21.1-16.2,31.8-1.4,7.4,10.3,37.7-2.2,37.7-2.2h0Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Vertical}`]: [
				'182.3 111.7 161.9 87.9 156.9 124.5 140.9 80.7 128.5 124.5 113.6 78.5 99.7 121.7 84.7 78.5 71.3 122.3 56.7 78.5 45.8 121.1 37.3 86.3 21.4 112.2',
			],
		},
	},
	[ToothView.BUCCAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M20.5,377.2c98-18.7,165.4,15.5,165.4,15.5l14.9,35.3,3.8,16.4.9,9.8-1.1,10-3.6,9.5-9.8,8.7-16.2,5.3-16,3.6-27.1-.2-19.1-6h-12.7s-22.6,3.8-22.6,3.8l-12.7-.2-6.7-.4-12.2-2.9-8-4-6-5.1-4.9-8-3.1-8.9-1.6-6.9-4.9-6.2-2.7-7.5-1.6-7.1-.7-8,.9-8.4,1.8-13.8,1.3-11.1,4-13.1h.3Z',
			},
			[ToothSurface.CervicalBuccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M185.7,392.9l-4.6-10.4c-69.9-38.6-158.3-13.3-158.3-13.3l-2.6,8.2c98.5-18.7,165.4,15.5,165.4,15.5h.1Z',
			},
			[ToothSurface.Buccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M117.3 424.9 A 13.9 13.9 0 1 1 89.5 424.9 A 13.9 13.9 0 1 1 117.3 424.9 Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M192.5,412.3l8,18,4,16.7-.7,16.7-4,9.8-7.8,7.3-14.4,6.2-20.6,4.4-14.2-.2v-66.8c0-10.4,9.8-12,9.8-12h40s-.1-.1-.1-.1Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M13.9,411.8l-1.8,6v13.8s3.3,12,3.3,12l6,8.4,2.9,11.1,4.9,10,8,8,9.5,4.2,24.2,3.6s.7-57.1.7-65.7c0-8.6-10.2-11.3-10.2-11.3H13.9h0Z',
			},
			[ToothSurface.DistoBuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M102.2,484.9s-5.2-51.6-16.4-68.4c-11.1-16.7-2.9-44.6-2.9-44.6-27.7-1.4-63,5.5-63,5.5l-5.4,18.2-2.4,19.5v14.7s2.9,13.3,2.9,13.3l6.7,10.4,1.6,8.2,4,9.1,6.7,8.7,12,6,14.7,3.3h13.5s15.1-2.2,15.1-2.2l13.1-1.8h-.2Z',
			},
			[ToothSurface.MesioBuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M185.6,393c-47.1-22-102.5-21.1-102.5-21.1,0,0-8,27.5,2.9,44.6,11.4,17.9,16.4,68.4,16.4,68.4l9.9.4,19.1,6,27.1.2,16-3.6,16.2-5.3,9.8-8.7,3.6-9.5,1.1-10-.9-9.8-3.8-16.4-14.9-35.3h0Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Horizontal}`]: [
				'202.1 437.2 176.9 412 172.2 450.9 152.5 405.2 140 451.8 121.5 403.7 107 449.7 88.6 404.6 74.6 451.1 56.8 405.4 45.5 450.7 35.1 413.9 17.9 440.7',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Vertical}`]: [
				'74.8 375.8 86 366.9 70.7 360.7 82.1 351.7 68 345.9 78.7 337.4 66.1 332.2 76.6 324 62 318 72.3 310.1 60.6 305.3 70.9 297.2 58.2 292.1 69 283.6 57.1 278.7 68 270.2 56.7 265.5 67.4 257.3 53.8 251.8 66.2 242.1 51.3 238 63.8 229.1 49.7 223.9 62.5 214.4 47.2 208.8 59.7 197.1 44.5 192.9 55.1 184.1 42.6 177.6 53.5 166.1 39.2 162.1 48.3 149.2 34.9 144.4 39.7 128.1',
				'124.1 112.9 121 135.7 133.7 136 128.2 149.6 143.4 153.1 133.4 163.6 146.5 170.3 137.1 178.9 149.7 185.2 138.9 193.2 150.8 200.7 136.3 208.7 149.3 216.7 136.4 223.7 149.6 231.8 137.3 238.7 150.6 247 137.8 253.9 149.2 261 138.6 266.9 150.2 274.1 138.9 280.2 150.6 287.5 138.5 294.1 149.6 300.9 138.5 306.9 149.6 313.7 135.8 321.2 147 328.3 135 334.8 147.4 343.6 133.3 349.4 144.9 358.7 131 364.9 143.6 376.6',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Horizontal}`]: [
				'173.3 256.6 158.6 240.9 145 257.6 128 240.1 114.2 258 102.8 240.6 89 257.8 74 242.1 64.1 258.9 47.6 242.3 39 257.8',
			],
		},
	},
};
